var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "loader--loaderWidget ls-flex ls-flex-column align-content-center align-items-center",
      staticStyle: { "min-height": "100%" },
      attrs: { id: "loader-" + _vm.id }
    },
    [_vm._m(0)]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "ls-flex align-content-center align-items-center" },
      [
        _c("div", { staticClass: "loader-toppanel text-center" }, [
          _c("div", { staticClass: "contain-pulse animate-pulse" }, [
            _c("div", { staticClass: "square" }),
            _c("div", { staticClass: "square" }),
            _c("div", { staticClass: "square" }),
            _c("div", { staticClass: "square" })
          ])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }